import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGetyonghuListQuery } from '../../store/dianshangtaizhangApi';

function FirmUserSelect(props) {
    const [list,setList] = useState();
    const {data,isSuccess} =useGetyonghuListQuery({
        yh_qy_id:props.qy_id,
        yh_phone:'',
        yh_name:'',
    }, {refetchOnMountOrArgChange: true})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {yh_id,yh_name,yh_phone} = item;
                    return item = {value:yh_id,label:yh_name,yh_phone }
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.formStyle}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        props.onChange(f.value,f.label,f.yh_phone)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.placeholder}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default FirmUserSelect